import { render, staticRenderFns } from "./SideRecap.vue?vue&type=template&id=180e823a"
import script from "./SideRecap.vue?vue&type=script&lang=ts"
export * from "./SideRecap.vue?vue&type=script&lang=ts"
import style0 from "./SideRecap.vue?vue&type=style&index=0&id=180e823a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports